// @ts-strict-ignore
import React from 'react'

interface VideoProps {
  videoId: string
  rawName: string
  variant: string
  title: string
  id: string
}

const Video: React.FC<VideoProps> = ({ videoId, rawName, variant, title, id }) => {
  try {
    return (
      <div
        className='yvideo'
        /* eslint-disable camelcase */
        data-click-tracking={JSON.stringify({
          component_category: 'platinum-component',
          component_id: id,
          component_name: 'youtube',
          contentful_name: rawName,
          contentful_variant: variant,
          additionalProps: { videoid: videoId, title: title },
        })}
      >
        {/* @ts-ignore */}
        <lite-youtube
          style={{
            backgroundImage: `url("https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg")`,
          }}
          videoid={videoId}
          params='loop=1&mute=1&modestbranding=1&rel=0'
        />
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default Video
